import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api';
import { BaseResponse, PublicSignupConfig } from 'types';

import { apiQuery } from '../../query';

export const projectsApi = createApi({
  baseQuery: apiQuery,
  reducerPath: 'projectsApi',
  endpoints: (build) => ({
    publicSignupConfig: build.query<PublicSignupConfig, void>({
      query: () => ({
        method: 'get',
        url: URL.PUBLIC_SIGNUP_CONFIG,
      }),
      transformResponse: (response: BaseResponse<PublicSignupConfig>) =>
        response.data,
    }),
  }),
});

export const { usePublicSignupConfigQuery } = projectsApi;
